import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Download } from 'lucide-react';
import { STATUS_OPTIONS } from './types';
import { LwSearchInput, LwButton, LW_DS_CLASS } from '@/components/lw';

export interface FilterValues {
  searchTerm: string;
  status: string;
  experience: string;
  dateRange: string;
}

interface RecruitmentFiltersProps {
  filters: FilterValues;
  onFilterChange: (filters: FilterValues) => void;
  onExport?: () => void;
}

// Derive filter options from STATUS_OPTIONS, prepending 'All Statuses'
const RECRUITMENT_STATUSES: { value: string; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  ...STATUS_OPTIONS
];

const EXPERIENCE_RANGES = [
  { value: 'all', label: 'All Experience' },
  { value: '0-3', label: '0-3 years' },
  { value: '3-7', label: '3-7 years' },
  { value: '7-12', label: '7-12 years' },
  { value: '12+', label: '12+ years' }
];

const DATE_RANGES = [
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 90 days' },
  { value: 'all', label: 'All Time' }
];

export const RecruitmentFilters: React.FC<RecruitmentFiltersProps> = ({ filters, onFilterChange, onExport }) => {
  return (
    <div className="toolbar">
      <LwSearchInput
        value={filters.searchTerm}
        onChange={(searchTerm) => onFilterChange({ ...filters, searchTerm })}
        placeholder="Search by name, email, NMLS…"
      />

      <div className="filter-row">
        {/* Status */}
        <Select value={filters.status} onValueChange={(status) => onFilterChange({ ...filters, status })}>
          <SelectTrigger className="w-44">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent className={LW_DS_CLASS}>
            {RECRUITMENT_STATUSES.map((status) => (
              <SelectItem key={status.value} value={status.value}>
                {status.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Experience */}
        <Select value={filters.experience} onValueChange={(experience) => onFilterChange({ ...filters, experience })}>
          <SelectTrigger className="w-44">
            <SelectValue placeholder="Experience" />
          </SelectTrigger>
          <SelectContent className={LW_DS_CLASS}>
            {EXPERIENCE_RANGES.map((range) => (
              <SelectItem key={range.value} value={range.value}>
                {range.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {/* Date range */}
        <Select value={filters.dateRange} onValueChange={(dateRange) => onFilterChange({ ...filters, dateRange })}>
          <SelectTrigger className="w-44">
            <SelectValue placeholder="Date Range" />
          </SelectTrigger>
          <SelectContent className={LW_DS_CLASS}>
            {DATE_RANGES.map((range) => (
              <SelectItem key={range.value} value={range.value}>
                {range.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="spacer" />

      {onExport && (
        <LwButton variant="sm" onClick={onExport}>
          <Download size={15} />
          Export
        </LwButton>
      )}
    </div>
  );
};
